export const BASE_URL = "https://ban.suisnap.cn/api";
export const UPLOAD_URL = "https://ban.suisnap.cn/api/common/upload";
// export const BASE_URL = "https://suipai.dingfengst.com/api";
// export const UPLOAD_URL = "https://suipai.dingfengst.com/api/common/upload";
